var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('form-answer',{attrs:{"checklist":_vm.checklist,"breadcrumb":_vm.breadcrumb,"currentQuestion":_vm.currentQuestion}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }